import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import type { EntityRegisterResponse } from '@risksmart-app/trpc/types';
import type { GetEntitiesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useIsFeatureVisibleToOrg } from 'src/utils/featureFlags';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcEntitiesToGraphQL = (
  trpcData?: EntityRegisterResponse
): GetEntitiesQuery => {
  return trpcData ?? { entity: [] };
};

export const useGetEntitiesTRPC = (skip?: boolean) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const trpc = useTRPC();
  const { addNotification } = useNotifications();
  const {
    data: trpcData,
    isLoading: trpcLoading,
    refetch: trpcRefetch,
    error: trpcError,
  } = useQuery({
    ...trpc.frontend.entity.register.queryOptions(),
    gcTime: 60,
    staleTime: 0,
    enabled: trpcEnabled && !skip, // Only enable TRPC query when flag is true
  });

  // Handle TRPC errors
  useEffect(() => {
    if (trpcEnabled && trpcError) {
      addNotification({
        type: 'error',
        content: <>{trpcError.message}</>,
      });
    }
  }, [trpcEnabled, trpcError, addNotification]);

  // Transform TRPC data to match the same structure as GraphQL query
  const data = mapTrpcEntitiesToGraphQL(trpcData);

  return {
    loading: trpcLoading,
    data,
    refetch: () => trpcRefetch(),
  };
};
